import { HintTooltip } from './HintTooltip';

export default HintTooltip;
